import styles from './CloseButton.module.scss';

interface CloseButtonProps {
  onClick: () => void;
}

export const CloseButton = ({ onClick }: CloseButtonProps) => (
  <button type="button" className={styles.button} onClick={onClick}>
    <span className={styles.span} />
    <span className={styles.span} />
  </button>
);
